import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Audit = () => {
    document.title = "Audit";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Göstəricilər", value: "/dashboard" },
        { name: "Audit", value: "/dashboard/main", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Audit</h2>
                    <p>
                        Sənədlərdə baş verən dəyişiklikləri <b>Audit</b> səhifəsində izləmək mümkündür.
                    </p>
                    <img src="/images/dashboard/audit.gif" alt="audit" />
                </article>
            </div>
        </div>
    );
};
